import { useContext } from "react";
import { SearchBoxContext } from "../SearchBoxContext/index.js";
const useShared = () => {
    const { i18n } = useContext(SearchBoxContext);
    return { i18n };
};
export default useShared;
